import(/* webpackMode: "eager" */ "/vercel/path0/app/promotion/[slug]/contact/components/ContactBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/promotion/[slug]/contact/components/ContactPage.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/promotion/[slug]/PromotionContext.js");
